/**
 * Created by Administrator on 2019/10/7.
 */
import { request, requestNew } from "../utils/request";
import serviceInterface from "../api/serviceInterface";

/**
 * 逐个搜索图片ID
 * @param params
 * @returns {*|Promise<unknown>|undefined}
 */
export const searchImage = (params) => {
  return request({
    url: serviceInterface.downLoad.searchImage,
    params: params,
    timeout: 15000,
  });
};

/**
 * 聚合搜索图片
 * @param params
 * @returns {*|Promise<unknown>|undefined}
 */
export const searchAll = (params) => {
  return request({
    url: serviceInterface.downLoad.searchAll,
    params: params,
    timeout: 25000,
  });
};

/**
 * 聚合搜索图片
 * @param params
 * @returns {*|Promise<unknown>|undefined}
 */
export const getKeyWords = (params) => {
  return request({
    url: serviceInterface.downLoad.getKeyWords,
    params: params,
    timeout: 18000,
  });
};

/**
 * 逐个搜索图片ID
 * @param params
 * @returns {*|Promise<unknown>|undefined}
 */
export const freeSearchImage = (params) => {
  return request({
    url: serviceInterface.downLoad.freeSearchImage,
    params: params,
    timeout: 25000,
  });
};

/**
 * 判断账户余额是否足以购买图片
 * @param params
 * @returns {*|Promise<unknown>|undefined}
 */
export const hasBlance = (params) => {
  return request({
    url: serviceInterface.downLoad.hasBlance,
    params: params,
    timeout: 90000,
  });
};

/**
 * 进行图片下载，并生产订单
 * @param params
 * @returns {*|Promise<unknown>|undefined}
 */
export const buy = (params) => {
  return request({
    url: serviceInterface.downLoad.buy,
    params: params,
    timeout: 180000,
  });
};

/**
 * 进行图片下载，并生产订单
 * @param params
 * @returns {*|Promise<unknown>|undefined}
 */
export const buy_delCarts = (params) => {
  return request({
    url: serviceInterface.downLoad.buy_delCarts,
    params: params,
    timeout: 180000,
  });
};

/**
 * 进行图片下载，并生产订单--等待模式
 * @param params
 * @returns {*|Promise<unknown>|undefined}
 */
export const buyWait = (params) => {
  return request({
    url: serviceInterface.downLoad.buyWait,
    params: params,
    timeout: 30000,
  });
};

/**
 * 进行图片下载，并生产订单--等待模式
 * @param params
 * @returns {*|Promise<unknown>|undefined}
 */
export const check = (params) => {
  return request({
    url: serviceInterface.downLoad.check,
    params: params,
    timeout: 30000,
  });
};

/**
 * 进行图片下载，并生产订单
 * @param params
 * @returns {*|Promise<unknown>|undefined}
 */
export const buyTemp = (params) => {
  return request({
    url: serviceInterface.downLoad.tempbuy,
    params: params,
    timeout: 300000,
  });
};

/**
 * 进行图片重新下载
 * @param params
 * @returns {*|Promise<unknown>|undefined}
 */
export const reDownload = (params) => {
  return request({
    url: serviceInterface.downLoad.reDownload,
    params: params,
  });
};

/**
 * 获取各素材网站费用明细
 * @param params
 * @returns {*|Promise<unknown>|undefined}
 */
export const chargesList = (params) => {
  return request({
    url: serviceInterface.brand.chargesList,
    params: params,
  });
};

/**
 * 次卡登陆接口
 * @param params
 * @returns {*|Promise<unknown>|undefined}
 */
export const tempLogin = (params) => {
  return requestNew({
    url: serviceInterface.downLoad.tempLogin,
    params: params,
    isShow: "1",
  });
};

/**
 * freepik次卡登陆接口
 * @param params
 * @returns {*|Promise<unknown>|undefined}
 */
export const ftempLogin = (params) => {
  return requestNew({
    url: serviceInterface.downLoad.ftempLogin,
    params: params,
    isShow: "1",
  });
};

/**
 * 获取shutter状态
 * @param params
 * @returns {*|Promise<unknown>|undefined}
 */
export const getShutterStatus = (params) => {
  return request({
    url: serviceInterface.downLoad.getStatus,
    params: params,
  });
};

/**
 * 缓存预览图片
 * @param params
 * @returns {*|Promise<unknown>|undefined}
 */
export const previewImage = (params) => {
  return request({
    url: serviceInterface.downLoad.previewImage,
    params: params,
  });
};
